import Vue from "vue";
import Vuex from "vuex";

import DealerStore from "@Scripts/Stores/DealerStore";
import MotorcycleStore from "@Scripts/Stores/MotorcycleStore";
import ProfileStore from "@Scripts/Stores/ProfileStore";
import RentalMarineStore from "@Scripts/Stores/RentalMarineStore";
import YESMarineStore from "@Scripts/Stores/YesMarineStore";
import YESStore from "@Scripts/Stores/YesStore";
import EventToolStore from "@Scripts/Stores/EventToolStore";

import ModuleVoucherCouponListStore from "@DataWeb/Scripts/Stores/ModuleVoucherCouponListStore";

Vue.use(Vuex);

export const store = new Vuex.Store({});

store.registerModule("dealerStore", DealerStore);
store.registerModule("motorcycleStore", MotorcycleStore);
store.registerModule("profileStore", ProfileStore);
store.registerModule("rentalMarineStore", RentalMarineStore);
store.registerModule("yesMarineStore", YESMarineStore);
store.registerModule("yesStore", YESStore);
store.registerModule("eventToolStore", EventToolStore);

store.registerModule("moduleVoucherCouponListStore", ModuleVoucherCouponListStore);